<template>
    <div>
        <h1
            class="theme-question-text-color theme-question-shadow mt-0 text-white uppercase font-size-24 md:font-size-38 text-center mb-0 md:mb-6 pt-6"
            v-html="title"
        ></h1>
        <div class="flex flex-col md:flex-row items-center justify-center pt-4 md:pt-0 md:mb-5">
            <div
                :style="{ 'background-image': 'url(' + getQuizImage(quizzes, true) + ')' }"
                class="layout-title-img w-48 h-48 md:w-64 md:h-64 border-ui-style bg-cover bg-center bg-norepeat"
            ></div>
            <div class="rank">
                <div class="rank-item" v-if="topRank[0]">
                    <img src="../assets/images/rank-1.png" />
                    <span class="uppercase truncate">{{ topRank[0].name }}</span>
                </div>
                <div class="rank-item" v-if="topRank[1]">
                    <img src="../assets/images/rank-2.png" />
                    <span class="uppercase truncate">{{ topRank[1].name }}</span>
                </div>
                <div class="rank-item" v-if="topRank[2]">
                    <img src="../assets/images/rank-3.png" />
                    <span class="uppercase truncate">{{ topRank[2].name }}</span>
                </div>
                <div class="flex justify-center" v-if="!isMaster && !ontopRank">
                    <span class="font-size-18 text-white uppercase shadow-text-none">{{ currentPlayerRank }}</span>
                </div>
            </div>
        </div>

        <!-- <div class="flex items-start justify-center pb-12 hidden">
            <ul class="list-reset" v-if="(typeof secondRank !== 'undefined')">
                <li :key="result.id" v-for="(result) in secondRank" class="flex items-center justify-start mb-1 flex-row">
                    <span v-if="playerName.length && playerName == result.name" class="icon-star"></span>
                    <span class="inline-flex text-white font-size-30 font-bold uppercase w-full">
                        <span class="mr-1">{{ result.number }}.</span>
                        <span class="player-name truncate inline-block">{{ result.name }}</span>
                    </span>
                </li>
            </ul>
            <ul class="list-reset ml-20" v-if="(typeof thirdRank !== 'undefined')">
                <li v-if="isThirdRankTopDot">
                    <span class="inline-block text-white font-size-30 font-bold uppercase">...</span>
                </li>
                <li :key="result.id" v-for="(result) in thirdRank" class="flex items-center justify-start mb-1 flex-row">
                    <span v-if="playerName.length && playerName == result.name" class="icon-star"></span>
                    <span class="inline-flex text-white font-size-30 font-bold uppercase w-full">
                        <span class="mr-1">{{ result.number }}.</span>
                        <span class="player-name truncate inline-block">{{ result.name }}</span>
                    </span>
                </li>
                <li v-if="isThirdRankBottomDot">
                    <span class="inline-block text-white font-size-30 font-bold uppercase">...</span>
                </li>
            </ul>
        </div> -->
    </div>
</template>

<script>
import helper from '@/lib/helper.js'
import gsap from 'gsap'
import { currentUser } from '@/lib/user.js'
import { mapState, mapGetters } from 'vuex'
import { load } from 'recaptcha-v3'
import helperMixins from '@/mixins/helper.js'

export default {
    name: 'QuizSummary',

    mixins: [helperMixins],

    props: {
        summary: Array,
        title: String,
        winnerName: String,
        quizImage: String,
        playerName: {
            default: '',
            type: String
        },
        quizzes: Object,
        isMaster: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            list: [],
            topRank: [],
            secondRank: [],
            thirdRank: [],
            isThirdRankTopDot: false,
            isThirdRankBottomDot: false
        }
    },

    computed: {
        ...mapGetters({
            quizRelate: 'getRelateQuiz'
        }),

        ...mapState({
            id: state => state.player.quiz._id,
            _id: state => state.question._id,
            code: state => state.player.quiz.code
        }),

        ontopRank() {
            return this.summary.findIndex(e => e.name === this.playerName) <= 2
        },

        currentPlayerRank() {
            const rank = this.summary.findIndex(e => e.name === this.playerName) + 1

            return `${rank}. ${this.playerName}`
        }
    },

    async mounted() {
        await this.checkRanking(
            this.summary.filter((item, index) => {
                return index < 3
            })
        )

        await this.$nextTick(() => {
            setTimeout(() => {
                window.dispatchEvent(new CustomEvent('componentAlready'))
            }, 200)
        })
    },

    methods: {
        checkRanking(playerList) {
            let transformData = []
            let arraySecondCenterIndex = 0
            let arraySize = playerList.length
            let excessRank = []

            if (playerList.length >= 13) {
                arraySize = Math.ceil(playerList.length / 2)
            }

            transformData = playerList.map((item, index) => {
                let isCurrentPlayer = this.playerName.length > 0 && this.playerName == item.name

                return {
                    ...item,
                    number: index + 1,
                    currentPlayer: isCurrentPlayer
                }
            })
            this.topRank = transformData.filter((item, index) => {
                return index <= 2
            })

            transformData = transformData.filter((item, index) => {
                return index > 2
            })

            this.list = helper.chunk(transformData, arraySize)

            if (this.list.length > 0) {
                this.secondRank = this.list[0].filter(item => {
                    return item.number < 11
                })
            }

            if (this.list.length > 1) {
                excessRank = this.list[0].filter(item => {
                    return item.number > 10
                })

                this.list[1] = [...excessRank, ...this.list[1]]

                if (typeof this.list[1] !== 'undefined') {
                    if (this.list[1].length > 5) {
                        arraySecondCenterIndex = Math.floor(this.list[1].length / 2 - 1)

                        this.list[1].forEach((item, index) => {
                            if (item.currentPlayer) {
                                arraySecondCenterIndex = index
                            }
                        })

                        if (this.list[1].length > 7) {
                            this.thirdRank = this.list[1].filter((item, index) => {
                                return (
                                    index === arraySecondCenterIndex - 1 ||
                                    index === arraySecondCenterIndex - 2 ||
                                    index === arraySecondCenterIndex ||
                                    index === arraySecondCenterIndex + 1 ||
                                    index === arraySecondCenterIndex + 2
                                )
                            })

                            this.isThirdRankTopDot =
                                typeof this.thirdRank[0] !== 'undefined' &&
                                this.list[1][0].number !== this.thirdRank[0].number
                            this.isThirdRankBottomDot =
                                typeof this.thirdRank[4] !== 'undefined' &&
                                this.list[1].length + 10 > this.thirdRank[4].number
                        } else {
                            this.thirdRank = this.list[1]
                        }
                    } else {
                        this.thirdRank = this.list[1]
                    }
                }
            }

            setTimeout(() => {
                this.sendEmailQuizPlayLive()

                if (this.topRank.length > 1) {
                    this.animateRanking()
                } else {
                    this.$emit('ended')
                }
            }, 0)
        },

        getRecaptchaSiteKey() {
            return process.env.VUE_APP_RECAPTCHA_SITE_KEY
        },

        sendEmailQuizPlayLive() {
            let dataUser = []
            for (let index in this.topRank) {
                let users = {
                    index: parseInt(index) + 1,
                    name: this.topRank[index].name
                }
                dataUser.push(users)
            }

            let data = {
                quiz_title: this.title,
                img_quiz: this.quizImage ? this.quizImage : this.getQuizImage(this.quizzes, true),
                player_count: this.summary.length,
                user: dataUser
            }

            setTimeout(() => {
                load(this.getRecaptchaSiteKey(), {
                    useRecaptchaNet: true,
                    autoHideBadge: true
                }).then(async recaptcha => {
                    const token = await recaptcha.execute('validate_captcha', { action: 'validate_captcha' })
                    this.$store.dispatch('sendEmailQuizPlayLive', {
                        quizId: !this.id ? this._id : this.id,
                        code: this.code,
                        userId: currentUser().id,
                        data: [data],
                        user_send_mail: [
                            {
                                email: currentUser().email,
                                name: currentUser().name
                            }
                        ],
                        quizRelate: this.quizRelate,
                        captcha_response: token
                    })
                })
            }, 500)
        },

        animateRanking() {
            let playerEle = document.getElementsByClassName('player-name')
            let eleLength = playerEle.length
            let staggerCount = 1
            let staggerCountReverse = eleLength

            let nameRank1 = this.topRank[0].name
            let nameRank2 = this.topRank.length > 1 ? this.topRank[1].name : null
            let nameRank3 = this.topRank.length > 2 ? this.topRank[2].name : null

            let isRank3 = nameRank3 != null

            let array1 = null
            let array2 = null
            let array3 = null

            if (isRank3) {
                array1 = [nameRank1, nameRank2, nameRank3]
                array2 = [nameRank2, nameRank3, nameRank1]
                array3 = [nameRank3, nameRank1, nameRank2]
            } else {
                array1 = [nameRank1, nameRank2]
                array2 = [nameRank2, nameRank1]
            }

            let count1 = 0
            let count2 = 0
            let count3 = 0
            let interval1 = null
            let interval2 = null
            let interval3 = null

            interval1 = setInterval(() => {
                if (count1 > 2 && isRank3) {
                    count1 = 0
                }

                if (count1 > 1 && !isRank3) {
                    count1 = 0
                }

                this.topRank[0].name = array1[count1]
                count1++
            }, 100)
            interval2 = setInterval(() => {
                if (count2 > 2 && isRank3) {
                    count2 = 0
                }

                if (count1 > 1 && !isRank3) {
                    count1 = 0
                }

                this.topRank[1].name = array2[count2]
                count2++
            }, 100)

            if (isRank3) {
                interval3 = setInterval(() => {
                    if (count3 > 2) {
                        count3 = 0
                    }
                    this.topRank[2].name = array3[count3]
                    count3++
                }, 100)
            }

            if (this.playerName.length > 0) {
                gsap.set('.icon-star', { opacity: 0 })
            }

            if (eleLength > 0) {
                gsap.from('.player-name', {
                    duration: 0.15,
                    opacity: 0,
                    stagger: {
                        amount: -1.5,
                        onComplete: () => {
                            if (
                                this.playerName.length > 0 &&
                                playerEle[staggerCountReverse - 1].parentElement.parentElement.children[0].classList
                                    .toString()
                                    .indexOf('icon-star') > -1
                            ) {
                                gsap.to('.icon-star', { duration: 0.25, opacity: 1 })
                            }

                            if (eleLength === staggerCount) {
                                this.finalResult(this.topRank, array1, array2, array3, interval1, interval2, interval3)
                            }

                            staggerCount++
                            staggerCountReverse--
                        }
                    }
                })
            } else {
                this.finalResult(this.topRank, array1, array2, array3, interval1, interval2, interval3)
            }
        },

        finalResult(topRank, array1, array2, array3, interval1, interval2, interval3) {
            let countFinal = 0
            let isArray3 = array3 != null
            let final = setInterval(() => {
                if (countFinal > 2 && isArray3) {
                    clearInterval(final)
                    this.$emit('ended')
                }

                if (countFinal > 1 && !isArray3) {
                    clearInterval(final)
                    this.$emit('ended')
                }

                switch (countFinal) {
                    case 0:
                        if (isArray3) {
                            clearInterval(interval3)
                        } else {
                            clearInterval(interval2)
                        }
                        setTimeout(() => {
                            if (isArray3) {
                                topRank[2].name = array3[0]
                            } else {
                                topRank[1].name = array2[0]
                            }
                        }, 100)
                        break
                    case 1:
                        if (isArray3) {
                            clearInterval(interval2)
                        } else {
                            clearInterval(interval1)
                        }
                        setTimeout(() => {
                            if (isArray3) {
                                topRank[1].name = array2[0]
                            } else {
                                topRank[0].name = array1[0]
                            }
                        }, 100)
                        break
                    case 2:
                        clearInterval(interval1)
                        setTimeout(() => {
                            topRank[0].name = array1[0]
                        }, 100)
                        break
                }

                countFinal++
            }, 500)
        }
    }
}
</script>

<style lang="scss" scoped>
.layout-title-img {
    box-shadow: 3px 3px 30px rgba(0, 0, 0, 0.5);

    @media (max-width: 767px) {
        //display: none;
    }
}

.list-reset li {
    position: relative;

    .icon-star {
        position: absolute;
        top: 50%;
        left: -1.5rem;
        transform: translateY(-50%);
        width: 1rem;
        height: 1rem;
        background-image: url('../assets/star.png');
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;

        @media (max-width: 767px) {
            left: -1rem;
            width: 0.75rem;
            height: 0.75rem;
        }
    }
}

.rank {
    padding-top: 0.75rem;
    margin-left: 3rem;

    @media (max-width: 767px) {
        margin-left: 0;
        min-height: 235px;
    }

    .rank-item {
        position: relative;
        width: 20rem;
        z-index: 10;

        @media (max-width: 767px) {
            width: calc(100% - 3rem);
        }

        &:nth-child(2),
        &:nth-child(3) {
            margin-top: -1.8rem;
        }

        &:nth-child(2) {
            margin-left: 1.5rem;
            z-index: 5;
        }

        &:nth-child(3) {
            margin-left: 3rem;
            z-index: 0;
        }

        img {
            max-width: 100%;
            pointer-events: none;
        }
        span {
            position: absolute;
            left: 30%;
            top: 45%;
            -webkit-transform: translateY(-50%);
            transform: translateY(-50%);
            font-weight: bold;
            font-size: 1.4rem;
            width: 59%;
            text-shadow: none;

            @media (max-width: 767px) {
                font-size: 1.3rem;
            }
        }
    }
}

@media (max-width: 767px) {
    .font-size-30 {
        font-size: 18px;
    }
    .ml-20 {
        margin-left: 2rem;
    }
    .list-reset {
        min-width: calc(50% - 2rem);
    }
}

/* Adjust scale over HD */
@media (min-width: 1950px) {
    .layout-title-img {
        width: calc(9vw + 9vh) !important;
        height: calc(9vw + 9vh) !important;
    }

    .rank .rank-item {
        width: calc(11.3vw + 11.3vh);

        &:nth-child(2),
        &:nth-child(3) {
            margin-top: calc((-0.95vw + -0.95vh));
        }

        &:nth-child(2) {
            margin-left: calc(0.9vw + 0.9vh);
        }

        &:nth-child(3) {
            margin-left: calc(1.8vw + 1.8vh);
        }

        img {
            width: 100%;
        }
        span {
            font-size: calc(0.85vw + 0.85vh);
        }
    }
}
</style>
